import { cardsCss, newCardsCss } from 'src/content/dashboard/DashboardCss';
import { pdfContainerSx } from './PdfSxs';
import { Box, CircularProgress, Typography } from '@mui/material';
import { CustomTooltip } from 'src/content/keywordResearch/CustomTooltip';
import { keywordResearchDashBoardCss } from 'src/content/keywordResearch/keywordResearchCSS';
import { cardsTexts } from 'src/content/dashboard/TextMessages';
import { useSelector } from 'react-redux';
import { RootState } from 'src/redux/store';
import { timeConverter } from '../config/FunctionHelper';
import { getProgressMode } from 'src/content/dashboard/AiComponentes/utils/functions';
export const PdfFirstCard = ({
  isNoGsc,
  reportMetaData
}: {
  isNoGsc?: boolean;
  reportMetaData?: any;
}) => {
  const siteAuditDetails = useSelector(
    (state: RootState) => state.siteAudit.siteAuditDetails
  );
  const pdfReportDataLoader = useSelector(
    (state: RootState) => state.dashboard.pdfReportDataLoader
  );
  let compareDate =
    useSelector((state: RootState) => state.siteAudit?.compareDate) ?? 0;
  const currentDate = new Date().getTime();
  let userDetails: any = useSelector(
    (state: RootState) => state.counter.userDetails
  );
  const pdfReportData = useSelector(
    (state: RootState) => state.dashboard.pdfReportData
  );

  const siteData = pdfReportData?.sitesDetail?.[0];
  const pdfDrCount = pdfReportData?.DR ?? siteData?.dr ?? null;

  // const mainScore = calculatePercentage(totalOptimized, totalScanned);
  const mainScore = pdfReportData?.healthScore;
  const progressValue = Math.round(mainScore || 0);

  const scoreDifference = pdfReportData?.healthScoreDiff;

  let progressColor = '#E64420';
  if (progressValue <= 50) {
    progressColor = '#E64420'; //red
  } else if (progressValue >= 51 && progressValue <= 65) {
    progressColor = '#ED9D1D'; //orange
  } else if (progressValue >= 66 && progressValue <= 75) {
    progressColor = '#F6E314'; //yellow
  } else if (progressValue >= 76 && progressValue <= 94) {
    progressColor = '#BEDA1E'; //chartreuse
  } else {
    progressColor = '#25D3B1'; //green
  }
  return (
    <>
      <div
        style={{
          ...pdfContainerSx?.pdfCardsSx,
          //...pdfContainerSx?.footerAlignBoxSx,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between'
        }}
      >
        <div>
          <div style={pdfContainerSx?.chipBoxSx}>
            <img
              src="/static/images/icons/score.svg"
              alt="icon"
              style={pdfContainerSx?.iconStyle}
            />
            <p style={pdfContainerSx?.chipTextSx}>{'SEO Health Score'}</p>
          </div>
          <div style={{ ...pdfContainerSx?.circleProgressMainBoxSx }}>
            {/* Circular Progress */}
            {pdfReportDataLoader && !pdfReportData ? (
              <Box sx={cardsCss?.loaderBox}>
                <CircularProgress
                  size={14}
                  color="inherit"
                  sx={newCardsCss?.circularLoadingSx}
                />
              </Box>
            ) : (
              <Box sx={pdfContainerSx?.circleProgressBoxSx}>
                <svg
                  viewBox="0 0 36 36"
                  width="170"
                  height="170"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ position: 'absolute', top: 0, left: 0 }}
                >
                  {/* Background Circle */}
                  <circle
                    cx="18"
                    cy="18"
                    r="15.915"
                    fill="transparent"
                    stroke="rgba(242, 244, 247, 1)" // Background color
                    strokeWidth="3"
                  />

                  {/* Progress Circle */}
                  <circle
                    cx="18"
                    cy="18"
                    r="15.915"
                    fill="transparent"
                    stroke={progressColor}
                    strokeWidth="3"
                    strokeDasharray="100" // Full circle
                    strokeDashoffset={`${(100 - progressValue) * (100 / 100)}`} // Offset for starting point
                    strokeLinecap="round"
                    transform="rotate(-90 18 18)" // Rotate to start at the top
                  />
                </svg>

                <CustomTooltip
                  title={
                    <Box>
                      <Typography
                        sx={keywordResearchDashBoardCss?.customTollTipText}
                      >
                        {`The SEO score of ${siteAuditDetails['url']?.replace(
                          /^www\./,
                          ''
                        )} is ${progressValue} — this is the average score of the ${
                          siteData?.total_sub_pages || 0
                        } pages analyzed.`}
                      </Typography>
                    </Box>
                  }
                  placement="bottom"
                >
                  {/* Text Inside the Progress */}
                  <Box sx={newCardsCss?.progressTextBoxSx}>
                    <Typography sx={newCardsCss?.progressTextSx}>
                      <span
                        style={{
                          ...newCardsCss?.progressTextSpanSx,
                          fontWeight: 600
                        }}
                      >
                        {progressValue}
                      </span>
                      {`/100`}
                    </Typography>
                    <Box
                      sx={{
                        ...cardsCss?.iconBoxCss,
                        ...pdfContainerSx?.iconBoxMarginCss
                      }}
                    >
                      {scoreDifference != null ? (
                        <>
                          {parseFloat(scoreDifference) == 0 ? (
                            <Typography sx={newCardsCss?.noChangesSx}>
                              {cardsTexts?.noChanges}
                            </Typography>
                          ) : parseFloat(scoreDifference) < 0 ? (
                            <>
                              <Box sx={newCardsCss?.trendingIconBoxSx}>
                                <img
                                  src="/static/images/icons/red_down.svg"
                                  alt="icon"
                                  style={{
                                    ...pdfContainerSx?.commonImgIconStyle,
                                    objectFit: 'contain'
                                  }}
                                />
                                <Typography
                                  sx={{
                                    ...cardsCss?.perSx,
                                    ...newCardsCss?.perNewSx
                                  }}
                                >
                                  {`${parseFloat(scoreDifference)}%`}
                                </Typography>
                              </Box>
                            </>
                          ) : (
                            <>
                              <Box sx={newCardsCss?.trendingIconBoxSx}>
                                <div
                                  style={{
                                    ...pdfContainerSx?.commonImgIconStyle,
                                    height: 'auto'
                                  }}
                                >
                                  <img
                                    src="/static/images/icons/green_up.svg"
                                    alt="icon"
                                    style={{}}
                                  />
                                </div>
                                <Typography
                                  sx={{
                                    ...cardsCss?.perSx,
                                    ...pdfContainerSx?.perSxFont
                                  }}
                                >
                                  {`${parseFloat(scoreDifference)}%`}
                                </Typography>
                              </Box>
                            </>
                          )}{' '}
                        </>
                      ) : (
                        <Typography sx={newCardsCss?.noChangesSx}>
                          {getProgressMode(progressValue)}
                        </Typography>
                      )}
                    </Box>
                  </Box>
                </CustomTooltip>
              </Box>
            )}
          </div>
          {pdfDrCount || pdfDrCount == 0 ? (
            <p
              style={{
                textAlign: 'center',
                marginTop: isNoGsc ? '8px' : '16px',
                ...pdfContainerSx?.drTextSx
              }}
            >
              Site DR:{' '}
              <span style={{ fontWeight: 600, color: '#120242' }}>
                {pdfDrCount}
              </span>
            </p>
          ) : (
            ''
          )}
        </div>
        {compareDate !== 0 && (
          <div
            style={{ textAlign: 'center', ...pdfContainerSx?.compareDateBoxSx }}
          >
            <p style={pdfContainerSx?.compareDateTextSx}>
              {` ${timeConverter(
                currentDate,
                userDetails?.date_format ||
                  reportMetaData?.dateFormat ||
                  'DD/MM/YYYY',
                true,
                true
              )}`}
              {' vs '}
              {timeConverter(
                compareDate,
                userDetails?.date_format ||
                  reportMetaData?.dateFormat ||
                  'DD/MM/YYYY',
                true,
                true
              )}
            </p>
          </div>
        )}
      </div>
    </>
  );
};
